<template>
  <div class="home">
    <div class="row mt-4" style="margin-left: -9vw">
      <div class="col-6 text-right">
        <img src="@/assets/trinnov_logo.svg" />
      </div>
      <div class="col-6 text-left">
        <img src="@/assets/waveforming_new.svg" />
      </div>
    </div>

    <div class="row" style="margin-top: 8vh">
      <div class="col"></div>
      <div 
        class="col-3 item-container clickable" 
        :class="textSelected === 'guidelines' ? 'active' : ''" 
        @mouseenter="textSelected = 'guidelines'"
        @click="openGuidelines"
      >
        <div class="row">
          <div class="col-9 highlightText mt-1">Design guidelines</div>
          <div class="col-3">
            <img src="@/assets/guidelines.svg" style="width: 3vw" />
          </div>
        </div>
      </div>

      <div 
        class="col-3 item-container clickable" 
        :class="textSelected === 'subwoofer' ? 'active' : ''" 
        @mouseenter="textSelected = 'subwoofer'"
        @click="redirectMenu('subwooferLayout')"
      >
        <div class="row">
          <div class="col-9 highlightText mt-1">Subwoofer layout</div>
          <div class="col-3">
            <img src="@/assets/monitors.svg" style="width: 2.6vw"/>
          </div>
        </div>
      </div>


      <div 
        class="col-3 item-container clickable"
        :class="textSelected === 'measures' ? 'active' : ''" 
        @mouseenter="textSelected = 'measures'"
        @click="redirectMenu('measures')"
      >
        <div class="row">
          <div class="col-9 highlightText mt-1">Measurement layout</div>
          <div class="col-3">
            <img src="@/assets/microphone.svg" />
          </div>
        </div>
      </div>

      <div class="col"></div>

    </div>

    <div class="text-center mt-4" style="width: 80%; margin-left: 10%; height: 35vh">
      {{ $t('home1_' + textSelected) }}
      <br />
      <br />
      {{ $t('home2_' + textSelected) }}
      <div v-if="textSelected === 'welcome'" class="highlightText">
        <br />
        {{ $t('home3_' + textSelected) }}
      </div>
    </div>

    <div class="text-center" style="width:80%; margin-left:10%">
      {{ $t('guidelinesHelp') }} <a :href="guidelinesLink" ref="guideLink" class="highlightText" target="_blank" style="text-decoration: underline;">{{ $t('guidelinesLinkTitle') }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "VHome",
  ///////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////
  data () {
    return {
      textSelected: "welcome",
      guidelinesLink: "https://www.trinnov.com/en/subwoofer-guidelines/"
    }
  },
  ///////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////
  methods: {
    handleButtonClicked: function(event) {
      if (event === this.textSelected)
        this.textSelected = "welcome";
      else
        this.textSelected = event;
    },
    ///////////////////////////////////////////////////////////////
    openGuidelines: function() {
      this.$refs.guideLink.click();
    },
    ///////////////////////////////////////////////////////////////
    redirectMenu: function(link) {
      if (link === "subwooferLayout")
        this.$router.push({name: 'room'});
      else if (link === "measures")
        this.$router.push({name: 'measures'});
    }
  }


}
</script>

<style lang="scss" scoped>
  .item-container {
    border: 3px solid grey;
    border-radius: 6px;
    margin-left: 0.2vw;
    padding: 1vh 1vw;

    &.active {
      border: 3px solid $active;
    }
  }

  .home {
    color: $whiteDim;

    .highlightText {
      color: white;
    }
  }
</style>
